import { render } from "./WhyFrenkel.vue?vue&type=template&id=cd95307e&scoped=true"
import script from "./WhyFrenkel.vue?vue&type=script&lang=js"
export * from "./WhyFrenkel.vue?vue&type=script&lang=js"

import "./WhyFrenkel.vue?vue&type=style&index=0&id=cd95307e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd95307e"]])

export default __exports__